// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mJpv","question":"styles_question__2gmUc","inputVisibleButton":"styles_inputVisibleButton__3TBn4","note":"styles_note__3CwWl"};